import { FC, ReactNode, CSSProperties } from 'react';
import { makeStyles } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/Check';
import clsx from 'clsx';
import { WbBadge, WbBadgeVariant } from '../WbBadge';

type WbEnabledBadgeProps = {
  className?: string;
  style?: CSSProperties;
  enabled: boolean;
  renderLabel?: (enabled: boolean) => ReactNode;
  enabledVariant?: WbBadgeVariant;
  disabledVariant?: WbBadgeVariant;
};

const useStyles = makeStyles(
  theme => ({
    statusBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(0.75),
      fontWeight: 400,
      color: theme.palette.black,
    },
  }),
  { name: 'WbEnabledBadge' },
);

export const WbEnabledBadge: FC<WbEnabledBadgeProps> = ({
  className,
  style,
  enabled,
  renderLabel,
  enabledVariant = 'soft',
  disabledVariant = 'disabled',
}) => {
  const classes = useStyles();

  let label: ReactNode = enabled ? 'Enabled' : 'Disabled';

  if (renderLabel) {
    label = renderLabel(enabled);
  }

  return (
    <WbBadge
      style={style}
      className={clsx(className, classes.statusBadge)}
      variant={enabled ? enabledVariant : disabledVariant}
      color={enabled ? 'success' : undefined}
    >
      {enabled ? (
        <CheckIcon fontSize="small" />
      ) : (
        <CancelIcon fontSize="small" />
      )}
      <span style={{ display: 'inline-block' }}>{label}</span>
    </WbBadge>
  );
};
